import { Component } from 'react';
import PropTypes from 'prop-types';
import { graphql, createFragmentContainer } from 'react-relay/legacy';
import { IntlContext, defineMessages } from 'dibs-react-intl';
import { Link } from 'dibs-elements/exports/Link';

// styles
import styles from './PdpSharedIconBubbles.scss';

import EmailIcon from 'dibs-icons/exports/Email';
import { PdpSharedSendToFriendModalLazy } from '../PdpSharedModals/PdpSharedSendToFriendModal/PdpSharedSendToFriendModalLazy';

// helpers
import { trackEmailClick } from '../tracking/iconBubblesTracking';

const messages = defineMessages({
    label: {
        id: 'PdpSharedIconBubbleEmail.label',
        defaultMessage: 'Share {title} by email',
    },
});
class PdpSharedIconBubbleEmailComponent extends Component {
    constructor(props) {
        super(props);

        this.state = {
            modalOpen: false,
            hasError: false,
            isLoggedIn: false,
            localSenderEmail: '',
        };

        this.onClick = this.onClick.bind(this);
        this.closeModal = this.closeModal.bind(this);
        this.openModal = this.openModal.bind(this);
        this.onUserLogin = this.onUserLogin.bind(this);
        this.setError = this.setError.bind(this);
    }

    componentDidMount() {
        const { user } = this.props;

        if (user) {
            this.setState({ isLoggedIn: true });
        }
    }

    componentDidUpdate(prevProps, prevState) {
        const { user } = this.props;

        if (user && !prevState.isLoggedIn) {
            this.setState({ isLoggedIn: true });
        }

        if (user && prevState.localSenderEmail) {
            // localSenderEmail becomes redundant upon fetching user data
            this.setState({ localSenderEmail: '' });
        }
    }

    closeModal() {
        this.setState({
            modalOpen: false,
            hasError: false,
        });
    }

    openModal() {
        this.setState({ modalOpen: true });
    }

    setError() {
        this.setState({ hasError: true });
    }

    onClick() {
        this.setState({ modalOpen: true }, () => {
            // fire tracking
            trackEmailClick(this.props.item.serviceId);
        });
    }

    onUserLogin(res) {
        if (!res.err) {
            const senderEmail = res.user?.profile?.email ?? '';
            this.setState({
                isLoggedIn: true,
                localSenderEmail: senderEmail,
            });
            this.openModal();
        }
    }

    render() {
        const { modalOpen, hasError, localSenderEmail, isLoggedIn } = this.state;
        const { item, skuId, user, viewer } = this.props;
        const { isPdpStfEnabled } = viewer || {};

        if (!isPdpStfEnabled) {
            return null;
        }

        let imageSrc = item.firstPhotoWebPath;
        if (skuId) {
            const sku = (item.skus || []).find(s => s.serviceId === skuId);
            const skuPhoto = sku?.firstPhotoWebPath;
            imageSrc = skuPhoto ? skuPhoto : imageSrc;
        }
        const senderEmail = user?.profile?.email ?? localSenderEmail;

        return (
            <Link
                className={styles.bubble}
                ariaLabel={this.context.formatMessage(messages.label, { title: item?.title })}
                onClick={this.onClick}
            >
                <EmailIcon className={styles.icon} />
                <PdpSharedSendToFriendModalLazy
                    key={senderEmail}
                    type="PDP"
                    modalOpen={modalOpen || hasError}
                    hasError={hasError}
                    senderEmail={senderEmail}
                    imageSrc={imageSrc}
                    skuId={skuId}
                    closeModal={this.closeModal}
                    onUserLogin={this.onUserLogin}
                    isLoggedIn={isLoggedIn}
                    setError={this.setError}
                    user={user}
                    item={item}
                    viewer={viewer}
                />
            </Link>
        );
    }
}

PdpSharedIconBubbleEmailComponent.contextType = IntlContext;

PdpSharedIconBubbleEmailComponent.propTypes = {
    relay: PropTypes.object.isRequired,
    viewer: PropTypes.object.isRequired,
    item: PropTypes.object.isRequired,
    user: PropTypes.object,
    skuId: PropTypes.string,
};

export const PdpSharedIconBubbleEmail = createFragmentContainer(PdpSharedIconBubbleEmailComponent, {
    viewer: graphql`
        fragment PdpSharedIconBubbleEmail_viewer on Viewer {
            ... @include(if: $fetchPdp) {
                isPdpStfEnabled: featureFlag(feature: "enablePdpStf")
                ...PdpSharedSendToFriendModalLazy_viewer
            }
        }
    `,
    item: graphql`
        fragment PdpSharedIconBubbleEmail_item on Item {
            serviceId
            title
            firstPhotoWebPath(size: small)
            skus {
                serviceId
                firstPhotoWebPath(size: small)
            }
            ...PdpSharedSendToFriendModalLazy_item
        }
    `,
    user: graphql`
        fragment PdpSharedIconBubbleEmail_user on User {
            profile {
                email
            }
            ...PdpSharedSendToFriendModalLazy_user
        }
    `,
});
